const outboundTypes = {
  VOLUNTARY: "Voluntary",
  EXPORT: "Export",
  LOCATION_TRANSFER: "Location transfer",
};

export default outboundTypes;
